// extracted by mini-css-extract-plugin
export var active = "index-module--active--WcoQt";
export var container = "index-module--container--fyFiz";
export var descriptionBox = "index-module--descriptionBox--LqjtZ";
export var slideShowBox = "index-module--slideShowBox--ALezf";
export var slideShowImage = "index-module--slideShowImage--grHKI";
export var slideshowImageContainer = "index-module--slideshowImageContainer--6Y26x";
export var subtitle = "index-module--subtitle--g8kcP";
export var tab = "index-module--tab--5gKgd";
export var tabContainer = "index-module--tabContainer--0bbuP";
export var title = "index-module--title--Ccisy";